import React, { useState } from "react";
import PropTypes from "prop-types";
import "../../styles/DocumentCard.css";
import { useDispatch } from "react-redux";
import { fetchAttecment } from "../../redux/actions/grievanceActions1";

const DocumentCard = ({
  filename,
  date,
  status,
  fileData,
  onPreview,
  onDownload,
  isLoading = false,
  showActions = true,
  additionalInfo,
  attachmentId,
  type,
}) => {
  // const [isLoading, setIsLoading] = useState(false);
  const dispatch = useDispatch();
  console.log(attachmentId, "attachmentId in DocumentCard");

  // Get file icon based on extension
  const getFileIcon = (fileName) => {
    const extension = fileName?.toLowerCase()?.split(".")?.pop();

    switch (extension) {
      case "pdf":
        return { icon: "bi-file-earmark-pdf", colorClass: "file-pdf" };
      case "jpg":
      case "jpeg":
      case "png":
      case "gif":
        return { icon: "bi-file-earmark-image", colorClass: "file-image" };
      case "doc":
      case "docx":
        return { icon: "bi-file-earmark-word", colorClass: "file-doc" };
      case "xls":
      case "xlsx":
        return { icon: "bi-file-earmark-excel", colorClass: "file-excel" };
      case "ppt":
      case "pptx":
        return { icon: "bi-file-earmark-ppt", colorClass: "file-ppt" };
      case "zip":
      case "rar":
        return { icon: "bi-file-earmark-zip", colorClass: "file-zip" };
      default:
        return { icon: "bi-file-earmark-text", colorClass: "file-other" };
    }
  };

  // Function to handle preview click and make API call - similar to TimelineItem2
  const handlePreview = async () => {
    onPreview(true);

    try {
      const res = await dispatch(fetchAttecment(attachmentId, type));
      console.log(res, "preview response");
      const attachmentData = res[0]?.ATTACHMENT;
      onPreview(false, attachmentData, filename);
      if (onPreview) {
        // onPreview( attachmentData ,filename);
      }
    } catch (error) {
      console.error("Error fetching attachment for preview:", error);
    } finally {
      // setIsLoading(false);
    }
  };

 

  const { icon, colorClass } = getFileIcon(filename);

  return (
    <div className="document-card">
      <div className={`document-preview ${colorClass}`}>
        <i className={`bi ${icon}`}></i>
      </div>
      <div className="document-details">
        <div className="document-name" title={filename}>
          {filename}
        </div>
        {showActions && (
          <div className="document-actions">
            <button
              className="doc-action"
              title="View"
              onClick={handlePreview}
              disabled={isLoading}
            >
              <i className="bi bi-eye"></i>
            </button>

          </div>
        )}
       
      </div>
    </div>
  );
};

DocumentCard.propTypes = {
  filename: PropTypes.string.isRequired,
  date: PropTypes.string,
  status: PropTypes.string,
  fileData: PropTypes.string,
  onPreview: PropTypes.func,
  onDownload: PropTypes.func,
  showActions: PropTypes.bool,
  additionalInfo: PropTypes.string,
  attachmentId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  type: PropTypes.string,
};

export default DocumentCard;
